import { render, staticRenderFns } from "./AlexHomepage.vue?vue&type=template&id=ff506ada&"
import script from "./AlexHomepage.vue?vue&type=script&lang=js&"
export * from "./AlexHomepage.vue?vue&type=script&lang=js&"
import style0 from "./AlexHomepage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports